"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const useProviderLogin_1 = __importDefault(require("../../../common/helpers/Hooks/useProviderLogin"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const Navigation_1 = __importDefault(require("../ShoppingCart/Navigation"));
const BalanceDetails_1 = __importDefault(require("./BalanceDetails"));
const StatusScreen_1 = __importDefault(require("./StatusScreen"));
const ExternalCheckinLinkout_1 = __importDefault(require("../Pages/ExternalCheckinLinkout"));
const Wrapper = styled_components_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1102;
  background: #fff;
  height: 100%;
  width: 100%;
  overflow: auto;
`;
const ContentWrapper = styled_components_1.default.div `
  max-width: 520px;
  margin-top: 56px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 600px) {
    margin-top: 64px;
  }
`;
const serverErrorDialog = {
    text: i18n_js_1.default.t("unknown_error_message"),
    actionTryAgain: i18n_js_1.default.t("try_again_button"),
    actionClose: i18n_js_1.default.t("cancel"),
};
const CheckBalanceFlow = (props) => {
    const { baseUrl, history, currentLocale, userData } = props;
    const [screenData, setScreenData] = (0, react_1.useState)({});
    const [dialogIsOpen, setDialogOpen] = (0, react_1.useState)(false);
    const [requestDialogIsOpen, setRequestDialogIsOpen] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [linkoutUrl, setLinkoutUrl] = (0, react_1.useState)(null);
    const { isLoginRequired, loginUrl } = (0, useProviderLogin_1.default)(userData);
    const getBalance = () => {
        if (!userData.token) {
            return;
        }
        setIsLoading(true);
        apiService_1.default
            .getBalance(currentLocale, userData.token)
            .then((data) => {
            if (data.linkoutUrl) {
                setLinkoutUrl(data.linkoutUrl);
                setIsLoading(false);
                return;
            }
            setScreenData(data);
            setIsLoading(false);
            if (data.status === "success") {
                setScreenData(data);
            }
            else {
                setRequestDialogIsOpen(true);
            }
        })
            .catch(() => {
            setDialogOpen(true);
            setIsLoading(false);
        });
    };
    (0, react_1.useEffect)(() => {
        getBalance();
    }, [userData]);
    if (isLoginRequired) {
        window.location.replace(loginUrl);
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const handleCancelBtn = () => {
        history.push(`${baseUrl}`);
    };
    if (linkoutUrl) {
        return (react_1.default.createElement(ExternalCheckinLinkout_1.default, { iframeSrc: linkoutUrl, headline: i18n_js_1.default.t("api_guest_journey_checkout_invoice_screen_details_screen_title"), withReducedHeight: true }));
    }
    return (react_1.default.createElement(Wrapper, { "data-testid": "check-balance-flow" },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Navigation_1.default, { icon: "close", onClick: () => {
                    handleCancelBtn();
                }, headline: screenData.texts && screenData.texts.detailsScreenTitle
                    ? screenData.texts.detailsScreenTitle
                    : i18n_js_1.default.t("api_guest_journey_checkout_invoice_screen_details_screen_title") }),
            react_1.default.createElement(material_1.Toolbar, null)),
        react_1.default.createElement(ContentWrapper, null,
            isLoading && react_1.default.createElement(Loader_1.default, { "data-testid": "loader-wrapper" }),
            screenData.screen === "balance_details" && (react_1.default.createElement(BalanceDetails_1.default, { balanceData: screenData })),
            screenData.screen === "status" && (react_1.default.createElement(StatusScreen_1.default, { statusData: screenData }))),
        react_1.default.createElement(material_1.Dialog, { open: dialogIsOpen },
            react_1.default.createElement(material_1.DialogContent, null, serverErrorDialog.text),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => {
                        setDialogOpen(false);
                        getBalance();
                    } }, serverErrorDialog.actionTryAgain),
                react_1.default.createElement(material_1.Button, { onClick: () => {
                        setDialogOpen(false);
                        history.replace(`${baseUrl}`);
                    } }, serverErrorDialog.actionClose))),
        react_1.default.createElement(material_1.Dialog, { open: requestDialogIsOpen },
            react_1.default.createElement(material_1.DialogContent, null, screenData.message),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => {
                        setRequestDialogIsOpen(false);
                        history.replace(`${baseUrl}`);
                    } }, serverErrorDialog.actionClose)))));
};
const mapStoreToProps = (store) => ({
    baseUrl: store.getValue("baseUrl"),
    userData: store.getValue("userData"),
    currentLocale: store.getValue("currentLocale"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(CheckBalanceFlow));
